import React, { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { useOperator } from "@/components/mobile/operators";
import { UnoExtras, UnoNumberCheck, useUnoCheck } from "@/components/mobile/UnoNumberCheck";
import { useUnoAccount } from "@/components/mobile/UnoAccount";

export const UnoExtrasTab = () => {
  const op = useOperator();
  const [form, setForm] = useState({ phone_number: "", iccid: "" });
  const [busyId, setBusyId] = useState("");
  const [refresh, setRefresh] = useState(0);
  const { choice } = useUnoAccount();
  const set = (k) => (e) => { setForm((s) => ({ ...s, [k]: e.target.value })); setRefresh(0); };
  const check = useUnoCheck(true, form.phone_number, form.iccid, "", refresh);
  const pick = async (x) => {
    setBusyId(x.id);
    try {
      const { data } = await api.post("/italiamobile/requests", { request_type: "cambio_promo", operator: op.key, ...form, piano: x.name, extra_id: x.id, uno_account: choice });
      if (data.status === "completata") toast.success(`${op.name}: ${data.operator_summary || `${x.name} attivo`}`);
      else toast.error(`${op.name} non ha attivato l'extra: ${data.operator_message || "riprova tra poco"}.`);
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Attivazione dell'extra non riuscita"); }
    finally { setBusyId(""); setRefresh((n) => n + 1); }
  };
  return (
    <Card className="p-6 glow-border space-y-4" data-testid="uno-extras-card">
      <p className="text-sm text-muted-foreground">Aggiungi GB, minuti, SMS o traffico estero a una SIM {op.name}. Li paga il cliente con il credito della SIM.</p>
      <div className="grid sm:grid-cols-2 gap-4">
        <div><Label>Numero {op.name} *</Label><Input type="tel" className="mt-1.5" data-testid="uno-x-phone" value={form.phone_number} onChange={set("phone_number")} placeholder="+39 3xx…" /><div className="mt-1.5"><UnoNumberCheck res={check} testid="uno-x-check" /></div></div>
        <div><Label>ICCID (facoltativo)</Label><Input className="mt-1.5" data-testid="uno-x-iccid" value={form.iccid} onChange={set("iccid")} placeholder="8939…" /></div>
      </div>
      <UnoExtras res={check} busyId={busyId} onPick={pick} />
      {check?.found && !(check.extras || []).length && <p className="text-xs text-muted-foreground" data-testid="uno-x-none">Su questa SIM non ci sono extra da attivare.</p>}
    </Card>
  );
};
